program Locker_Editor_1;



{$R *.dres}

uses
  Vcl.Forms,
  WEBLib.Forms,
  LockerEditor1 in 'LockerEditor1.pas'{*.html},
  uLockerController in 'uLockerController.pas',
  uLockerDataStore in '..\..\LockerDataStore\uLockerDataStore.pas',
  uLockerDataStore_JSON in '..\..\LockerDataStore\uLockerDataStore_JSON.pas',
  uLockerDataStore_MySQL in '..\..\LockerDataStore\uLockerDataStore_MySQL.pas',
  uButtonPanel in 'uButtonPanel.pas',
  uGridEditBlock in 'uGridEditBlock.pas',
  uLockerContracts in 'uLockerContracts.pas',
  uLockerStorageBinding in 'uLockerStorageBinding.pas',
  uConstants in 'uConstants.pas',
  uLockerState in 'uLockerState.pas';

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TLockerEditor1_form, LockerEditor1_form);
  Application.Run;
end.
